export default {"src":"/_next/static/media/atom-thumbs-up.12d4c855.svg","height":170,"width":139,"blurWidth":0,"blurHeight":0};